import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";

export enum AffinityConfig {
  HSR_FILTER_CODE = "hsrFilterCode",
  HSR_FILTERS = "hsrFilters",
}

const starRatingMap = {
  "1 Star": 1,
  "2 Star": 2,
  "3 Star": 3,
  "4 Star": 4,
  "5 Star": 5,
};
export function getStarRating(flexContext: ExtendedContextStore): number | undefined {
  const starRatingCode: string | undefined =
    flexContext &&
    flexContext.searchContext &&
    flexContext.searchContext.starRating &&
    flexContext.searchContext.starRating.code;

  return starRatingMap[starRatingCode];
}

export function getHSRStarRatingCode(flexContext: ExtendedContextStore): number | undefined {
  const starRating = getStarRating(flexContext);

  return starRating && starRating * 10; // HSR accepts 10, 20, 30, 40, 50.
}

export function getAffinityAttribute(flexContext: ExtendedContextStore, key: string) {
  const affinity = (flexContext && flexContext.searchContext && flexContext.searchContext.affinity) || {};

  return affinity[key];
}

export function getHSRFilterCode(flexContext: ExtendedContextStore): string | undefined {
  return getAffinityAttribute(flexContext, AffinityConfig.HSR_FILTER_CODE);
}

export function getHSRFilters(flexContext: ExtendedContextStore): { [key: string]: string } | undefined {
  return getAffinityAttribute(flexContext, AffinityConfig.HSR_FILTERS);
}

export function getPropertyTypeCode(context: ExtendedContextStore): string | undefined {
  const propertyType =
    context &&
    context.searchContext &&
    context.searchContext.alternativeAccommodation &&
    context.searchContext.alternativeAccommodation.lodgingUrlCode;

  if (propertyType === null) {
    return undefined;
  }

  const isBoundleAASearchExpEnabled = isVariantEnabled(
    context,
    Experiment.Bex_Bundle_AA_property_types_during_search,
    1
  );
  const bundlePropertyTypesFilters = ["apartment", "apartHotel", "condo", "vacationHome", "condoResort"];
  const bundlePropertyTypesTargets = ["apartment", "apartHotel", "villa", "condo", "vacationHome", "condoResort"];

  if (isBoundleAASearchExpEnabled && bundlePropertyTypesFilters.includes(propertyType)) {
    return bundlePropertyTypesTargets.join(",");
  }

  return propertyType;
}
